export default {
  list: [
    {
      value: 'WAITING',
      color: 'text-muted',
      title: 'در انتظار برای بررسی',
    },
    {
      value: 'FIRST_REJECTION',
      color: 'text-warning',
      title: 'رد اولیه',
    },
    {
      value: 'FINAL_REJECTION',
      color: 'text-danger',
      title: 'رد نهایی',
    },
    {
      value: 'ACCEPTED',
      color: 'text-primary',
      title: 'ثبت قرارداد شده',
    },
    {
      value: 'ACCEPTED_WITHOUT_REGISTRATION_FEE',
      color: 'text-primary',
      title: 'ثبت قرارداد شده بدون هزینه',
    },
    {
      value: 'ACCEPTED_WITHOUT_CONTRACT',
      color: 'text-bold-success',
      title: 'تایید شده',
    },
    {
      value: 'REGISTERED',
      color: 'text-dark',
      title: 'ثبت سیستمی',
    },
    {
      value: 'REGISTERED_WITHOUT_REGISTRATION_FEE',
      color: 'text-dark',
      title: 'ثبت سیستمی بدون هزینه',
    },
  ],
  values: {
    WAITING: 'WAITING',
    FIRST_REJECTION: 'FIRST_REJECTION',
    FINAL_REJECTION: 'FINAL_REJECTION',
    ACCEPTED: 'ACCEPTED',
    ACCEPTED_WITHOUT_REGISTRATION_FEE: 'ACCEPTED_WITHOUT_REGISTRATION_FEE',
    REGISTERED: 'REGISTERED',
    REGISTERED_WITHOUT_REGISTRATION_FEE: 'REGISTERED_WITHOUT_REGISTRATION_FEE',
  },
};
